import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import * as PreviewAPI from '../../../API/PreviewAPI'
import { immer } from 'zustand/middleware/immer'

const initialState = {
    getAllBodyPreviewData: {},
    getAllBodyPreviewDataLoading: false
}

const BodyPreviewStore = create(devtools(immer((set, get) => ({
    ...initialState,
    getAllBodyPreview: async (userId, orgId, bodyType, roleId) => {
        set({ ...initialState, getAllBodyPreviewDataLoading: true })
        const response = await PreviewAPI.GetAllBodyPreview(userId, orgId, bodyType, roleId)
        if (response.data) {
            set({ ...initialState, getAllBodyPreviewDataLoading: false, getAllBodyPreviewData: response?.data })
            return response
        } else {
            set({ ...initialState, getAllBodyPreviewDataLoading: false })
        }
    }

    // createBoardMember: async (loginId, data) => {
    //     set({ ...initialState, createBoardMemberDataLoading: true })
    //     const response = await BodyPreview.createBoardMember(loginId, data)
    //     if (response.data) {
    //         set({ ...initialState, createBoardMemberDataLoading: false, createBoardMemberData: response?.data })
    //         return response
    //     } else {
    //         set({ ...initialState, createBoardMemberDataLoading: false })
    //         return response
    //     }
    // }

}))))

export const useBodyPreviewStore = BodyPreviewStore
